import React, {Fragment, useState} from 'react';
import {Checkbox, FormControl, Stack, Typography, useTheme} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {StyledBox, StyledCheckbox} from './styles';
import {TermsCheckboxProps} from './types';
import {ConsentModal} from '../ConsentModal';

const {requiredField} = translations['pt-br'].commons;
const {
	terms: {readAndAgree, termConsent},
} = translations['pt-br'].privateFlow.businessAccessPermission;

const TermsCheckbox = ({
	termsCheckedState,
	setTermsCheckedState,
	isCheckboxRequiredState,
}: TermsCheckboxProps) => {
	const theme = useTheme();
	const [openConsentModalState, setOpenConsentModalState] = useState(false);

	const checkboxColor = !isCheckboxRequiredState
		? theme.palette.text.primary
		: theme.palette.error.main;

	return (
		<Fragment>
			<FormControl>
				<StyledCheckbox
					control={
						<Checkbox
							checked={termsCheckedState}
							onChange={(_, checked) => setTermsCheckedState(checked)}
							sx={{
								color: checkboxColor,
								padding: 'initial',
							}}
						/>
					}
					label={
						<Stack>
							<Typography variant="body2" color={checkboxColor}>
								{readAndAgree}{' '}
								<StyledBox
									as="span"
									onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
										e.preventDefault();
										setOpenConsentModalState(true);
									}}>
									{termConsent}
								</StyledBox>
							</Typography>
						</Stack>
					}
				/>
				{isCheckboxRequiredState ? (
					<Typography variant="helperText" ml={4} color={checkboxColor}>
						{requiredField}
					</Typography>
				) : null}
			</FormControl>

			<ConsentModal
				consentModalOpen={openConsentModalState}
				setConsentModalOpen={() => setOpenConsentModalState(false)}
			/>
		</Fragment>
	);
};

export default TermsCheckbox;
